var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeGears(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 265.16 383.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.7;}.cls-2{fill:#d2cad9;}.cls-3{fill:#b3e0db;}.cls-4{opacity:0.59;}.cls-5{fill:url(#New_Gradient_Swatch_11);}.cls-6{fill:none;stroke:#b498c6;stroke-miterlimit:10;stroke-width:1.04px;}.cls-7{fill:#b498c6;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_11",
    x1: -853.65,
    y1: 523.12,
    x2: -828.08,
    y2: 523.12,
    gradientTransform: "translate(1107.63 154.93) rotate(22.19)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffca66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47a4d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "StartUp_NewHome",
    "data-name": "StartUp NewHome"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M258.91,349.4l5.92-15.15a4.83,4.83,0,0,0-2.74-6.25l-6.9-2.7a4.78,4.78,0,0,1-3.08-4.39c0-.51,0-1,0-1.52a4.78,4.78,0,0,1,2.89-4.54l6.79-3a4.84,4.84,0,0,0,2.49-6.37l-6.53-14.89a4.83,4.83,0,0,0-6.36-2.49l-6.8,3a4.78,4.78,0,0,1-5.29-.95c-.36-.36-.72-.71-1.09-1.05a4.79,4.79,0,0,1-1.15-5.24l2.7-6.91a4.83,4.83,0,0,0-2.74-6.25l-15.15-5.92a4.84,4.84,0,0,0-6.26,2.74l-2.69,6.91a4.8,4.8,0,0,1-4.4,3.07c-.51,0-1,0-1.52,0a4.76,4.76,0,0,1-4.53-2.88l-3-6.8a4.83,4.83,0,0,0-6.36-2.49l-14.9,6.53a4.83,4.83,0,0,0-2.48,6.36l3,6.8a4.77,4.77,0,0,1-.94,5.29c-.36.36-.71.72-1.06,1.1a4.8,4.8,0,0,1-5.24,1.14l-6.9-2.69a4.83,4.83,0,0,0-6.26,2.74l-5.91,15.14a4.83,4.83,0,0,0,2.74,6.26l6.9,2.7a4.76,4.76,0,0,1,3.07,4.39c0,.51,0,1,0,1.52a4.79,4.79,0,0,1-2.89,4.54l-6.8,3a4.84,4.84,0,0,0-2.48,6.37l6.53,14.89a4.83,4.83,0,0,0,6.36,2.49l6.79-3a4.77,4.77,0,0,1,5.3.95c.35.35.72.71,1.09,1.05a4.78,4.78,0,0,1,1.15,5.24l-2.7,6.9a4.84,4.84,0,0,0,2.74,6.26l15.15,5.92a4.84,4.84,0,0,0,6.26-2.74l2.69-6.91a4.79,4.79,0,0,1,4.39-3.07c.51,0,1,0,1.53,0a4.8,4.8,0,0,1,4.53,2.89l3,6.8a4.83,4.83,0,0,0,6.36,2.48L239,370.14a4.83,4.83,0,0,0,2.49-6.37l-3-6.79a4.79,4.79,0,0,1,1-5.29c.36-.36.71-.73,1.06-1.1a4.78,4.78,0,0,1,5.24-1.14l6.9,2.69A4.82,4.82,0,0,0,258.91,349.4Zm-57.23-5.28a24.12,24.12,0,1,1,28.6-12.53A24.12,24.12,0,0,1,201.68,344.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M149.17,373l2.21-5.54a1.77,1.77,0,0,0-1-2.3l-2.52-1a1.74,1.74,0,0,1-1.12-1.62c0-.18,0-.37,0-.56a1.75,1.75,0,0,1,1.07-1.65l2.5-1.07a1.77,1.77,0,0,0,.93-2.33l-2.35-5.48a1.77,1.77,0,0,0-2.33-.93l-2.5,1.07a1.76,1.76,0,0,1-1.94-.36l-.39-.39a1.75,1.75,0,0,1-.41-1.93l1-2.52a1.77,1.77,0,0,0-1-2.3l-5.54-2.22a1.77,1.77,0,0,0-2.3,1l-1,2.53a1.77,1.77,0,0,1-1.62,1.11h-.56a1.74,1.74,0,0,1-1.65-1.07l-1.08-2.5a1.77,1.77,0,0,0-2.33-.93l-5.48,2.35a1.78,1.78,0,0,0-.93,2.33l1.08,2.5a1.75,1.75,0,0,1-.37,1.94l-.39.4a1.74,1.74,0,0,1-1.92.4l-2.53-1a1.77,1.77,0,0,0-2.3,1l-2.21,5.54a1.77,1.77,0,0,0,1,2.3l2.52,1a1.76,1.76,0,0,1,1.12,1.62c0,.19,0,.37,0,.56a1.78,1.78,0,0,1-1.08,1.66l-2.5,1.07a1.78,1.78,0,0,0-.93,2.33l2.36,5.48a1.77,1.77,0,0,0,2.32.93l2.5-1.08a1.76,1.76,0,0,1,1.94.37l.4.39a1.76,1.76,0,0,1,.41,1.92l-1,2.53a1.77,1.77,0,0,0,1,2.3l5.54,2.21a1.77,1.77,0,0,0,2.3-1l1-2.52a1.74,1.74,0,0,1,1.62-1.12h.56a1.74,1.74,0,0,1,1.65,1.07L134,382a1.77,1.77,0,0,0,2.32.93l5.48-2.36a1.76,1.76,0,0,0,.93-2.32l-1.07-2.5a1.76,1.76,0,0,1,.36-1.94c.14-.13.27-.27.39-.4a1.78,1.78,0,0,1,1.93-.41l2.52,1A1.78,1.78,0,0,0,149.17,373Zm-21.9.88a12,12,0,1,1,14.22-6.11A12,12,0,0,1,127.27,373.88Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M142.61,328.2l1.37-3.37a1.06,1.06,0,0,0-.59-1.4l-1.53-.63a1.06,1.06,0,0,1-.67-1c0-.11,0-.23,0-.34a1.08,1.08,0,0,1,.66-1l1.53-.64a1.08,1.08,0,0,0,.58-1.41l-1.41-3.35a1.08,1.08,0,0,0-1.41-.58l-1.53.64a1.05,1.05,0,0,1-1.18-.23l-.24-.24a1,1,0,0,1-.24-1.17l.62-1.54a1.07,1.07,0,0,0-.59-1.4l-3.36-1.38a1.08,1.08,0,0,0-1.41.6l-.63,1.53a1.05,1.05,0,0,1-1,.67h-.34a1,1,0,0,1-1-.66l-.65-1.52a1.08,1.08,0,0,0-1.41-.58l-3.35,1.41a1.08,1.08,0,0,0-.58,1.41l.65,1.53a1.09,1.09,0,0,1-.23,1.18,2.72,2.72,0,0,0-.24.24,1.08,1.08,0,0,1-1.18.24l-1.53-.63a1.08,1.08,0,0,0-1.41.6l-1.37,3.36a1.08,1.08,0,0,0,.59,1.41l1.53.63a1,1,0,0,1,.67,1c0,.11,0,.22,0,.34a1.07,1.07,0,0,1-.66,1l-1.53.64A1.09,1.09,0,0,0,119,325l1.41,3.35a1.08,1.08,0,0,0,1.41.58l1.53-.65a1.07,1.07,0,0,1,1.18.23l.24.24a1.06,1.06,0,0,1,.24,1.18l-.62,1.53a1.08,1.08,0,0,0,.59,1.41l3.36,1.37a1.07,1.07,0,0,0,1.41-.59l.63-1.53a1.06,1.06,0,0,1,1-.68h.34a1.07,1.07,0,0,1,1,.66l.65,1.53a1.08,1.08,0,0,0,1.41.58l3.35-1.41a1.09,1.09,0,0,0,.58-1.42l-.64-1.52a1.05,1.05,0,0,1,.23-1.18l.24-.24a1,1,0,0,1,1.17-.24l1.53.62A1.07,1.07,0,0,0,142.61,328.2Zm-13.34.43A7.28,7.28,0,1,1,138,325,7.28,7.28,0,0,1,129.27,328.63Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 5.67,
    y1: 362.54,
    x2: 132.08,
    y2: 362.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M136.19,359.55a5.73,5.73,0,0,1-7.66,7.66,5.11,5.11,0,0,1-2.57-2.57,5.73,5.73,0,0,1,7.66-7.66A5.11,5.11,0,0,1,136.19,359.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M213.34,318.9a5.73,5.73,0,0,1-7.66,7.66,5.07,5.07,0,0,1-2.56-2.56,5.73,5.73,0,0,1,7.66-7.66A5,5,0,0,1,213.34,318.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M136.53,319.07a5.73,5.73,0,0,1-7.66,7.66,5.05,5.05,0,0,1-2.56-2.57A5.73,5.73,0,0,1,134,316.5,5.05,5.05,0,0,1,136.53,319.07Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "5.67 361.76 5.67 321.95 210.39 321.95"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 207.71,
    y: 5.67,
    width: 1.04,
    height: 318.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 207.71,
    cy: 5.67,
    r: 5.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 5.67,
    cy: 321.95,
    r: 5.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 5.67,
    cy: 361.76,
    r: 5.67
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeGears);
export default __webpack_public_path__ + "static/media/threeGears.081b3735703d1a41e501688c8beea6bb.svg";
export { ForwardRef as ReactComponent };